
<div *ngIf="searchTerm">
You searched for "{{ searchTerm }}". You can do what you need in this component to process that term.
</div>
